import React from "react";

import "../css/legend.css";
import {Card, ListGroup} from "react-bootstrap";
import LegendCircle from "./LegendCircle";
import LegendLine from "./LegendLine";

interface LegendProps {
  children?: React.ReactNode;
}

const Legend = ({children}: LegendProps) => {
  const hasSupplement = React.Children.count(children) > 0;

  return <Card id="legend" className="text-white">
    <Card.Body>
      <Card.Title as="h5">Legend</Card.Title>
      <ListGroup variant="flush">
        <ListGroup.Item className="d-flex align-items-center text-white border-0 py-0">
          <div style={{ width: "1.25em" }} className="d-flex justify-content-center">
            <LegendCircle colour="#d9d9d9" size=".8em"/>
          </div>
          <span className="ms-2">Gene</span>
        </ListGroup.Item>
        <ListGroup.Item className="d-flex align-items-center text-white border-0 py-0">
          <div style={{ width: "1.25em" }} className="d-flex justify-content-center">
            <LegendLine colour="#d9d9d9" height={2}/>
          </div>
          <span className="ms-2">Genetic interaction profile similarity (PCC)</span>
        </ListGroup.Item>
      </ListGroup>
      {hasSupplement && (
        <>
          <hr/>
          {children}
        </>
      )}
    </Card.Body>
  </Card>
};

export default Legend;
